import React from 'react';
import PropTypes from 'prop-types';
import EditButton from 'components/button/EditButton';
import styled from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ImageIcon, LockIcon } from 'assets/materialIcons/materialIcons';

const StyledColumn = styled.div`
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex: 1;
    margin: 0 10px;
    flex-direction: column;
    background: ${ theme.palette.white };

    ${ (props) => {
        if (!props.padding) {
            return;
        }

        return `padding: 10px 20px`;
    } };

    ${ (props) => {
        if (!props.border) {
            return;
        }

        return `box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 6px, rgba(0, 0, 0, 0.08) 0px 1px 4px`;
    } };

    ${ (props) => {
        const { size } = props;

        if (!size) {
            return 'flex-grow: 1';
        }

        return `flex-basis: ${ (100 / 12) * size }%`;
    } };

    &:first-child {
        margin-left: 0;
    }

    &:last-child {
        margin-right: 0;
    }
`;

const StyledTitle = styled.div`
    display: inline-block;
    position: relative;
    margin: 5px 0 15px;
    flex: 1;
    font-size: 14px;
    line-height: 1.4;
    text-transform: uppercase;
    color: ${ theme.palette.doveGray };
`;

const StyledActions = styled.div`
    position: absolute;
    display: flex;
    top: 0;
    right: 0;
    z-index: 1;
`;

const ColumnContent = styled.div`
    display: flex;
    flex-basis: 100%;
`;

const StyledErrorMessageField = styled.div`
    position: relative;
    padding: 0 16px;
    display: inline-block;
    color: ${ theme.palette.tomato };
`;

const Column = (props) => {
    const {
        actions,
        border,
        children,
        editEnabled,
        editRoute,
        errorMessage,
        padding,
        size,
        title,
        translate,
    } = props;

    const buttonStyle = {
        borderTopLeftRadius: '0',
        borderTopRightRadius: '0',
        borderBottomRightRadius: '0',
    };

    return (
        <StyledColumn
            border={ border }
            padding={ padding }
            size={ size }
        >
            { (editRoute || actions) &&
                <StyledActions>
                    { actions &&
                        React.cloneElement(actions)
                    }

                    { editRoute &&
                        <EditButton
                            buttonStyle={ buttonStyle }
                            disabled={ !editEnabled }
                            icon={ editEnabled ? <ImageIcon color={ theme.palette.primary1Color } /> : <LockIcon /> }
                            label={ translate('actions.edit') }
                            url={ editRoute }
                        />
                    }
                </StyledActions>
            }

            { (title || errorMessage) &&
                <div>
                    { title && (
                        <StyledTitle> { title }</StyledTitle>
                    ) }

                    { errorMessage && (
                        <StyledErrorMessageField>
                            { errorMessage }
                        </StyledErrorMessageField>
                    ) }
                </div>
            }

            <ColumnContent>
                { children }
            </ColumnContent>
        </StyledColumn>
    );
};

Column.defaultProps = {
    border: true,
    padding: true,
    size: 0,
    title: null,
};

Column.propTypes = {
    actions: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.element,
    ]),
    border: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element,
    ]),
    editEnabled: PropTypes.bool,
    editRoute: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]),
    errorMessage: PropTypes.string,
    padding: PropTypes.bool,
    size: PropTypes.number,
    title: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

export default translate(Column);



// WEBPACK FOOTER //
// ./src/components/ui/show/Column.js